// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3apux","dragIcon":"Choice_dragIcon__3tZRp","left":"Choice_left__2WudG","input":"Choice_input__33IAn"};